import React from "react"
import {
    Container,
    IconWrapper,
    Title,
    Description,
} from "QuorumGrassroots/widgets/ReusableComponents/EmptyState/EmptyState.styles"
import { UsersIcon } from "QuorumGrassroots/widgets/ReusableComponents/UsersIcon/UsersIcon"

export interface EmptyStateProps {
    icon: string
    title: string
    description: string
    dataCy?: string
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, dataCy }) => {
    return (
        <Container data-cy={dataCy}>
            <IconWrapper>
                <UsersIcon />
            </IconWrapper>
            <Title>{title}</Title>
            <Description>{description}</Description>
        </Container>
    )
}
